import RestClient from "../rest.client"

export default class AccumulatorsService {
    static async setVirtualOdometer(deviceId: number, odometer: number) {
        console.log(`Set Virtual Odometer: ${odometer * 1000} to ${deviceId}`)
        return await RestClient.call({
            url: `/devices/${deviceId}/accumulators`,
            method: 'put',
            headers: { 'Authorization': localStorage.getItem('token') },
            data: {
                deviceId: deviceId,
                totalDistance: odometer * 1000
            }
        })
    }

    static async setVirtualHorometer(deviceId: number, horometer: number) {
        console.log(`Set Virtual Horometer: ${horometer * 3600000} to ${deviceId}`)
        return await RestClient.call({
            url: `/devices/${deviceId}/accumulators`,
            method: 'put',
            headers: { 'Authorization': localStorage.getItem('token') },
            data: {
                deviceId: deviceId,
                hours: horometer * 3600000
            }
        })
    }
} 